var map = {
	"./skill1.svg": [
		133,
		133
	],
	"./skill10.svg": [
		471,
		471
	],
	"./skill11.svg": [
		454,
		454
	],
	"./skill12.svg": [
		767,
		767
	],
	"./skill13.svg": [
		545,
		545
	],
	"./skill14.svg": [
		718,
		718
	],
	"./skill15.svg": [
		624,
		624
	],
	"./skill16.svg": [
		936,
		164
	],
	"./skill17.svg": [
		814,
		814
	],
	"./skill18.svg": [
		366,
		366
	],
	"./skill19.svg": [
		188,
		188
	],
	"./skill2.svg": [
		166,
		166
	],
	"./skill20.svg": [
		337,
		337
	],
	"./skill21.svg": [
		361,
		361
	],
	"./skill3.svg": [
		720,
		720
	],
	"./skill4.svg": [
		36,
		36
	],
	"./skill5.svg": [
		644,
		644
	],
	"./skill6.svg": [
		870,
		870
	],
	"./skill7.svg": [
		812,
		812
	],
	"./skill8.svg": [
		432,
		432
	],
	"./skill9.svg": [
		450,
		450
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 858;
module.exports = webpackAsyncContext;